<template>
  <el-scrollbar>
    <el-menu
      active-text-color="#1890ff"
      background-color="#282828"
      class="el-menu-vertical-demo"
      :default-active="$route.path"
      text-color="#ddd"
      unique-opened
      :collapse="isCollapse"
  >
    <template v-for="(item,index) in menuList" :key="index">

      <el-sub-menu v-if="item.children && item.children.length > 0" :index="String(item.id)">
        <template #title>
          <ElIcons v-if="item.css" :name="item.css" />
          <ElIcons v-else name="FolderAdd" />
          <span>{{item.name}}</span>
        </template>
        <template v-for="(child, index) in item.children" :key="index">
          <router-link :to="child.url">
            <el-menu-item :index="child.url">
              {{child.name}}
            </el-menu-item>
          </router-link>
        </template>
      </el-sub-menu>

      <router-link v-else :to="item.url">
        <el-menu-item :index="item.url">
          <ElIcons v-if="item.css" :name="item.css" />
          <ElIcons v-else name="Document" />
          <template #title>{{item.name}}</template>
        </el-menu-item>
      </router-link>

    </template>
  </el-menu>
  </el-scrollbar>
</template>

<script>

export default {
  name: "sidebar",
  data() {
    return {

    }
  },
  methods: {

  },
  computed: {
    menuList() {
      return JSON.parse(localStorage.getItem('menuList'))
    },
    isCollapse() {
      return this.$store.state.sidebar.opened
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
